import { render, staticRenderFns } from "./TalkDetail.vue?vue&type=template&id=b901bd22&scoped=true"
import script from "./TalkDetail.vue?vue&type=script&lang=js"
export * from "./TalkDetail.vue?vue&type=script&lang=js"
import style0 from "./TalkDetail.vue?vue&type=style&index=0&id=b901bd22&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b901bd22",
  null
  
)

export default component.exports